import Axios from 'axios';
const token = localStorage.getItem("token");
const isDev = process.env.NODE_ENV === "debug";
const cfg = {
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    },
};
export default {
    getKzdoc() {
        let uri = '/api/ext/kzdoc/tree';
        if (isDev) {
            uri = uri.replace("/api", "");
        }
        else {
            uri = `${location.origin}` + uri;
        }
        return Axios.get(uri, cfg);
    },
    getUrl(id, params) {
        let uri = `/api/ext/document/getPreviewInfo2?uid=${id}`;
        if (isDev) {
            uri = uri.replace("/api", "");
        }
        else {
            uri = `${location.origin}` + uri;
        }
        cfg.params = params;
        return Axios.get(uri, cfg);
    },
    getList(id, type, libraryCode) {
        let uri = `/api/ext/kzdoc/tree?projectId=${id}&type=${type || ''}&libraryCode=${libraryCode || ''}`;
        if (isDev) {
            uri = uri.replace("/api", "");
        }
        else {
            uri = `${location.origin}` + uri;
        }
        return Axios.get(uri, cfg);
    },
    getZipUrl(refIds) {
        let uri = `/api/ext/document/getZipUrl?refIds=${refIds}`;
        if (isDev) {
            uri = uri.replace("/api", "");
        }
        else {
            uri = `${location.origin}` + uri;
        }
        return Axios.get(uri);
    }
};
